import React, { useCallback, useState, useContext } from 'react';
import { connect } from 'react-redux';
import { func, node, oneOf, string } from 'prop-types';
import Spinner from '@prisjakt/ui-spinner';
import { AppContext } from '@prisjakt/ui-app-context';

import feedbackActions from './actions';
import * as S from './styles';

const FeedbackButton = ({
  className,
  children,
  open,
  startChat,
  position,
  title,
}) => {
  const {
    market: { lazyLoadIntercom },
  } = useContext(AppContext);

  const [loadState, setLoadState] = useState('init');

  const load = useCallback(() => {
    // If intercom lazy load is disabled, simply open
    // the standard form
    if (!lazyLoadIntercom) {
      open();
      return;
    }

    window.onIntercomLoadedCb = successful => {
      if (!successful) {
        open();
        setLoadState('failed');
      } else {
        setLoadState('loaded');
      }

      window.onIntercomLoadedCb = undefined;
    };

    if (loadState === 'failed') {
      open();
    } else {
      if (loadState === 'init') {
        setLoadState('loading');
      }
      startChat();
    }
  }, [lazyLoadIntercom, loadState, open, startChat]);

  return (
    <S.FeedbackButton
      className={className}
      color="primary"
      position={position}
      onClick={load}
      data-test="FeedbackButton"
      title={title}
    >
      <Spinner active={loadState === 'loading'} />
      {children}
    </S.FeedbackButton>
  );
};

FeedbackButton.propTypes = {
  className: string,
  children: node.isRequired,
  open: func.isRequired,
  position: oneOf(['inline', 'bottom-right', 'right']),
  title: string,
  startChat: func.isRequired,
};

FeedbackButton.defaultProps = {
  className: undefined,
  position: 'inline',
  title: '',
};

export default connect(
  state => state.footer,
  feedbackActions
)(FeedbackButton);
